import React from "react";

export default function SectionTitle({
  eyebrow,
  title,
  scriptWord,
  subtitle,
  align = "center",
  className = "",
}) {
  const alignClass = align === "left" ? "text-left items-start" : "text-center items-center";
  return (
    <div className={`flex flex-col ${alignClass} gap-4 ${className}`}>
      {eyebrow && (
        <span className="divider-lily text-xs tracking-[0.32em] uppercase font-body">
          {eyebrow}
        </span>
      )}
      <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.05] tracking-tight">
        {title}
        {scriptWord && (
          <>
            {" "}
            <span className="font-script text-petal text-[1.15em] align-baseline">
              {scriptWord}
            </span>
          </>
        )}
      </h2>
      {subtitle && (
        <p className="max-w-2xl text-charcoal-soft text-base sm:text-lg leading-relaxed font-body">
          {subtitle}
        </p>
      )}
    </div>
  );
}
